/**
 * Time Info API - Operacije za vremenske informacije
 */

import { httpClient } from '../client/httpClient';
import { TimeInfoData } from '../types/apiTypes';
import { logError } from '../utils/errorHandler';

export const timeInfoApi = {
  /**
   * Dohvati vremenske informacije za određenu sesiju
   * Returns raw API response data for backward compatibility
   */
  getTimeInfo: async (sessionId: string): Promise<unknown> => {
    try {
      const response = await httpClient.get<unknown>(
        `/api/training/get-time-info/${sessionId}`
      );

      if (!response.success) {
        // Return null for 404 errors (no data)
        return null;
      }

      return response.data || null;
    } catch (error) {
      logError('timeInfoApi.getTimeInfo', error);
      throw error;
    }
  },

  /**
   * Stvori ili ažuriraj vremenske informacije za određenu sesiju
   */
  upsertTimeInfo: async (
    sessionId: string,
    timeInfoData: TimeInfoData
  ): Promise<unknown> => {
    try {
      const response = await httpClient.post<unknown>('/api/training/save-time-info', {
        sessionId,
        timeInfo: timeInfoData,
      });

      if (!response.success) {
        throw new Error(response.error || 'Failed to save time info');
      }

      return response.data;
    } catch (error) {
      logError('timeInfoApi.upsertTimeInfo', error);
      throw error;
    }
  },

  /**
   * Legacy support - ažuriraj vremenske informacije
   */
  updateTimeInfo: async (
    sessionId: string,
    timeInfo: Record<string, unknown>
  ): Promise<unknown> => {
    return timeInfoApi.upsertTimeInfo(sessionId, timeInfo as TimeInfoData);
  },
};
